import React from "react";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
import MxSelectTrustField from "@rf-l1/form/selects/MxSelectTrustField";
import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type MxFormSelectTrustFieldProp = Omit<MxAutoCompleteFieldProps, omit>

const MxFormSelectTrustField = (props: MxFormSelectTrustFieldProp) => {
  const { onChange, onBlur, name, value, invalid, id, testId, inputRef } =
    useMxFieldControllerContext();

  return (
    <MxSelectTrustField
      {...props}
      id={id}
      testId={testId}
      inputRef={inputRef}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormSelectTrustField;
